import React, { createContext, useContext, useMemo } from "react";
import { canUserEdit, isSubUserAnalyst } from "../utils/subUser";

const SubUserAccessContext = createContext(null);

export function SubUserAccessProvider({ user, children }) {
  const value = useMemo(
    () => ({
      canEdit: canUserEdit(user),
      isAnalystViewOnly: isSubUserAnalyst(user),
    }),
    [user]
  );

  return (
    <SubUserAccessContext.Provider value={value}>
      {children}
    </SubUserAccessContext.Provider>
  );
}

export function useSubUserAccess() {
  const ctx = useContext(SubUserAccessContext);
  if (!ctx) {
    return { canEdit: true, isAnalystViewOnly: false };
  }
  return ctx;
}

export function useCanEdit() {
  return useSubUserAccess().canEdit;
}
